import { Pipe, PipeTransform } from '@angular/core'
import { imageUrl } from '@helpers/common'

@Pipe({ name: 'imageUrl' })
export class ImageUrlPipe implements PipeTransform {
    constructor() {
    }

    transform(src: string, type: string = ''): any {
        if (src) {
            if (!src.startsWith(imageUrl)) {
                src = imageUrl + src
            }
            if (type) {
                src += '?type=' + type
            }
            return src
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/image-url.pipe.ts